<template>
  <div>
    <div
      v-if="Object.keys(agency).length === 0"
      class="d-flex justify-content-center mb-1"
    >
      <b-spinner label="Loading..." />
    </div>
    <div v-else>
      <breadcrumbs
        :breadcrumb-items="breadcrumbItems"
      />
      <UserToolbar
        v-if="account && Object.keys(account).length !== 0"
        :account="account"
      />
      <b-form @submit.prevent>
        <validation-observer ref="validationAgencyMemberRules">
          <b-tabs
            pills
          >
            <b-tab active>
              <!-- title -->
              <template #title>
                <feather-icon
                  icon="SettingsIcon"
                  size="18"
                  class="mr-50"
                />
                <span class="font-weight-bold">{{ $t('Settings') }}</span>
              </template>
              <b-card>
                <div class="head-card">
                  <div class="head-card-top">
                    <h4>{{ $t('partners.settings') }}</h4>
                    <feather-icon
                      v-b-tooltip.hover.top="$t('Close')"
                      icon="XIcon"
                      size="18"
                      class="toggle-close cursor-pointer"
                      @click="$router.go(-1)"
                    />
                  </div>
                  <hr>
                </div>
                <b-row v-if="Object.keys(member).length !== 0">
                  <b-col md="6">
                    <b-form-group
                      :label="$t('partners.agencyrate')"
                      label-for="i-rate"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="rate"
                        rules="required"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length == 0 || 'is-invalid'"
                        >
                          <b-input-group-prepend is-text>
                            <feather-icon icon="LayoutIcon" />
                          </b-input-group-prepend>
                          <b-form-input
                            id="i-name"
                            v-model="member.rate"
                            type="number"
                            placeholder="50.0"
                            :state="errors.length > 0 ? false:null"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <template v-if="authUserData.role.includes('admin')">
                      <b-form-group
                        :label="$t('partners.phoenixrate')"
                        label-for="i-phoenixrate"
                      >
                        <b-input-group
                          class="input-group-merge"
                        >
                          <b-input-group-prepend is-text>
                            <feather-icon icon="LayoutIcon" />
                          </b-input-group-prepend>
                          <b-form-input
                            id="i-phoenixrate"
                            v-model="member.phoenixrate"
                            type="number"
                            placeholder="0"
                          />
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                        :label="$t('partners.campaignrate')"
                        label-for="i-campaignrate"
                      >
                        <b-input-group
                          class="input-group-merge"
                        >
                          <b-input-group-prepend is-text>
                            <feather-icon icon="LayoutIcon" />
                          </b-input-group-prepend>
                          <b-form-input
                            id="i-campaignrate"
                            v-model="member.campaignrate"
                            type="number"
                            placeholder="0"
                          />
                        </b-input-group>
                      </b-form-group>
                    </template>

                    <b-form-group class="mt-1">
                      <b-form-checkbox
                        v-model="show_logo"
                        value="1"
                      >
                        {{ $t('partners.showlogo') }}
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                        v-model="show_amount"
                        value="1"
                      >
                        {{ $t('partners.showamount') }}
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    md="12"
                    class="d-flex align-items-center justify-content-end mt-1"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-secondary"
                      class="mr-0 mr-sm-1"
                      @click="$router.go(-1)"
                    >
                      <feather-icon
                        icon="ChevronLeftIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">{{ $t('form.back') }}</span>
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      @click="agencyUpdate"
                    >
                      <span class="align-middle">{{ $t('form.save') }}</span>
                      <feather-icon
                        icon="ChevronRightIcon"
                        class="ml-50"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>
            <!--/ general tab -->
          </b-tabs>
        </validation-observer>
      </b-form>
    </div>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BCard,
  BForm,
  BFormGroup,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
  BFormCheckbox,
  BSpinner,
  VBTooltip,
  BButton,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  required,
  integer,
  min,
} from '@validations'
import Breadcrumbs from '@/views/ui/breadcrumbs/Breadcrumbs.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import UserToolbar from '@/views/dashboard/users/UserToolbar.vue'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    BCard,
    Breadcrumbs,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BButton,
    UserToolbar,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      pageTitle: 'Site edit',
      min,
      required,
      integer,
      account: {},
      authUserData: getUserData(),
      agency: [],
      member: {},
      breadcrumbItems: [],
      show_logo: [],
      show_amount: [],
    }
  },
  created() {
    this.getUserData()
  },
  methods: {
    async getAgencyData() {
      const responseData = await useJwt.getAgency(this.$route.params.id)
      this.agency = responseData.data.agency || []
      this.getMemberData(this.$route.params.memberId)
    },
    getMemberData(memberId) {
      const memberIdx = this.agency.members.findIndex(m => m.user_id === memberId)
      this.member = this.agency.members[memberIdx]
      if (this.member.show_logo) {
        this.show_logo.push(1)
      }
      if (this.member.show_amount) {
        this.show_amount.push(1)
      }
      this.setBreabcrumbs()
    },
    agencyUpdate() {
      this.member.show_logo = this.show_logo
      this.member.show_amount = this.show_amount

      if (this.member.phoenixrate === '') {
        this.member.phoenixrate = 0
      }

      if (this.member.campaignrate === '') {
        this.member.campaignrate = 0
      }

      this.$refs.validationAgencyMemberRules.validate().then(success => {
        if (success) {
          useJwt.setAgencyMember(this.$route.params.id, this.member)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Agency member update',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        }
      })
    },
    async getUserData() {
      const responseData = await useJwt.getUser(this.$route.params.userId)
      this.account = responseData.data.account || {}
      this.pageTitle = this.account.name
      this.pageSubtitle = this.account.email
      this.getAgencyData()
    },
    async setBreabcrumbs() {
      this.breadcrumbItems = [
        {
          text: this.$t('Users'),
          to: '/users/',
        },
        {
          text: this.account.name,
          to: `/users/${this.agency.owner}`,
        },
        {
          text: this.$t('Partners'),
          to: `/users/${this.agency.owner}/agencies`,
        },
        {
          text: this.agency.title,
          active: true,
        },
      ]
    },
  },
}
</script>
